module.exports = __webpack_public_path__ + "static/e-banquet-illu-4-dc7ea90b7abb5067787c3719ba36a5e5.png";